import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { CompanyLicenseInformation } from '../../types/CompanyLicenseInformation';

export abstract class LicenseMainFormBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getCompanyLicenseInformation(editedCompanyId?: string | null): Promise<CompanyLicenseInformation>;
}
